import { c as _c } from "react/compiler-runtime";
import { postInvestigationsByInvestigationIdSourcesOptions } from '@onefootprint/fetch-dashboard';
import type { InvestigationSourceDetail } from '@onefootprint/request-types/dashboard';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
export type { InvestigationSourceDetail };
export type CitationPair = {
  sourceLabel: string;
  locator: string;
};
export const citationKey = (sourceLabel: string, locator: string) => `${sourceLabel}|${locator}`;

/**
 * One request hydrates the investigation's `[S#]` sources and resolves every `[S# <locator>]`
 * citation parsed from the live document, grouping each source's evidence under it. The backend
 * echoes a requested citation with `evidence` only when its locator actually resolves, so a cite
 * with no passage to show simply comes back bare. Resolve-on-read: nothing is stored.
 */
const useSources = (investigationId, t0) => {
  const $ = _c(7);
  let t1;
  let t2;
  if ($[0] !== investigationId || $[1] !== t0) {
    const pairs = t0 === undefined ? [] : t0;
    const citations = [...pairs].sort(_temp);
    t2 = useQuery;
    t1 = postInvestigationsByInvestigationIdSourcesOptions({
      path: {
        investigationId: investigationId ?? ""
      },
      body: {
        citations
      }
    });
    $[0] = investigationId;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  const t3 = !!investigationId;
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = {
      ...t1,
      enabled: t3,
      placeholderData: keepPreviousData
    };
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t2(t4);
};
export default useSources;
function _temp(a, b) {
  return citationKey(a.sourceLabel, a.locator).localeCompare(citationKey(b.sourceLabel, b.locator));
}